var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
// eslint-disable-next-line no-restricted-imports
import { restoreFile } from '../../features/file-manager/utils/restoreFile';
import { showFileExistsDialog } from './showFileExistsDialog';
import { showOriginalLocationRemovedDialog } from './showOriginalLocationRemovedDialog';
export function showRestoreDialog(params) {
    const { t, file, fileEntityType } = params;
    showConfirmDialog({
        title: t('restoreFileDialog.title', { fileName: file.columns.name }),
        content: t('restoreFileDialog.content', { fileEntityType: fileEntityType.toLowerCase() }),
        confirmLabel: t('common.restore'),
        onConfirm: () => handleRestore(params),
    });
}
export function handleRestore(_a) {
    return __awaiter(this, arguments, void 0, function* ({ storage, t, functionClient, file, fileEntityType, onSuccess }) {
        var _b, _c, _d;
        const originalLocationIsRoot = ((_b = file.columns.path) === null || _b === void 0 ? void 0 : _b.indexOf('/')) === -1;
        const parentPath = !originalLocationIsRoot ? (_c = file.columns.path) === null || _c === void 0 ? void 0 : _c.replace(/\/[^\/]*$/, '') : undefined;
        try {
            const originalParentByPath = yield storage.listFiles({
                filter: [{ column: 'path', op: '=', value: parentPath }],
                archived: false,
                flatList: true,
            });
            const parentId = (_d = originalParentByPath.rows[0]) === null || _d === void 0 ? void 0 : _d.id;
            const parentExists = originalParentByPath.total > 0;
            const originalLocationExists = originalLocationIsRoot || (parentPath && parentExists);
            const originalLocationRemoved = parentPath && !parentExists;
            const fileInLocationExists = yield storage.isFileExists({ name: file.columns.name, parentId });
            if (originalLocationExists && fileInLocationExists.exists) {
                showFileExistsDialog(t, file.columns.name, fileEntityType);
            }
            else if (originalLocationRemoved) {
                showOriginalLocationRemovedDialog(t, storage, functionClient, file.columns.name, fileEntityType, file.id, onSuccess);
            }
            else {
                restoreFile(functionClient, fileEntityType, onSuccess, file.id, parentId);
            }
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
    });
}
